'use client'

import styles from './Nav.module.css'
import Link from 'next/link';
import { useEffect, useState } from 'react';

import {
  Button,
  Chip,
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@indxsearch/systm';
import { Github, Book, Nuget, Key, Four_leaf_clover, Sunrise } from "@indxsearch/pixl";

const docsVersions = [
  { label: 'V5', status: 'Latest', Icon: Sunrise, href: 'https://v5.docs.indx.co' },
  { label: 'V4', status: 'Previous', Icon: Four_leaf_clover, href: 'https://docs.indx.co' },
];

export default function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 700px)');
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return (
    <header id={styles.header}>
      <Link href="/" id={styles.logo}>
        <span>Indx</span>
      </Link>

      <nav id={styles.nav}>
        <div className={styles.menuToggle}>
          <Button
            size="default"
            variant="ghost"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-expanded={menuOpen}
            aria-controls="menu"
          >
            {menuOpen ? 'Close' : 'Menu'}
          </Button>
        </div>
        <div id={styles.menu} className={menuOpen ? styles.menuOpen : ''}>

          <NavigationMenu
            className={styles.docsNav}
            aria-label="Main"
            size="large"
            align="end"
            panelWidth={240}
            orientation={isMobile ? 'vertical' : 'horizontal'}
          >
            <NavigationMenuList>
              <NavigationMenuItem>
                <NavigationMenuLink variant="navigation" icon={<Nuget />} href="https://www.nuget.org/packages/IndxSearchLib/">
                  Nuget
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuTrigger icon={<Book />}>Docs</NavigationMenuTrigger>
                <NavigationMenuContent>
                  {docsVersions.map((v) => (
                    <NavigationMenuLink key={v.label} href={v.href} className={styles.docsItem}>
                      <span className={styles.docsLabel}>
                        <v.Icon size={14} color="currentColor" />
                        {v.label}
                      </span>
                      <Chip>{v.status}</Chip>
                    </NavigationMenuLink>
                  ))}
                </NavigationMenuContent>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink variant="navigation" icon={<Github />} href="https://github.com/indxsearch">
                  Github
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink variant="navigation" icon={<Key />} href="https://license.indx.co">
                  Licenses
                </NavigationMenuLink>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </div>
      </nav>
    </header>
  )
}
